import { render } from "./MemberLeftNav.vue?vue&type=template&id=20f6dd94&scoped=true"
import script from "./MemberLeftNav.vue?vue&type=script&lang=js"
export * from "./MemberLeftNav.vue?vue&type=script&lang=js"

import "./MemberLeftNav.vue?vue&type=style&index=0&id=20f6dd94&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f6dd94"]])

export default __exports__